import { Button } from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { api } from "@/api";
import appConfig from "@/config/appConfig";
import { flare } from "@flareapp/js";

export default function Profile() {
  const [userDetails, setUserDetails] = useState({});

  const getProfile = async () => {
    try {
      const data = await api.get("/user/me");
      setUserDetails(data);
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log(error);
    }
  };

  useEffect(() => {
    document.title = `${appConfig.name} - Profile`;
    getProfile();
  }, []);
  return (
    <div className="az-content-body p-0 px-md-3">
      <div className="row row-sm mg-b-15 mg-sm-b-20">
        <div className="col-lg-12">
          <div className="card card-dashboard-six">
            <div className="card-header">
              <div>
                <label className="az-content-label">Profile</label>
                <span className="d-block py-2">Your Profile Information</span>
              </div>
            </div>
            <div className="row g-4">
              <div className="col-md-6 order-2 order-md-1">
                <div className="row mb-2">
                  <div className="col-4">Full Name</div>
                  <div className="col-8">: {userDetails?.name}</div>
                </div>
                <div className="row mb-2">
                  <div className="col-4">Email</div>
                  <div className="col-8">: {userDetails?.email ? userDetails?.email : " --"} </div>
                </div>
                {/* {userDetails?.role !== userRole.superAdmin ? ( */}
                <div className="row mb-2">
                  <div className="col-4">Login ID</div>
                  <div className="col-8">: {userDetails?.loginId ? userDetails?.loginId : " --"} </div>
                </div>
                {/* ) : (
                  ""
                )} */}
                <div className="row mb-2">
                  <div className="col-4">Phone Number</div>
                  <div className="col-8">:{userDetails?.phone ? <> +6{userDetails?.phone}</> : " --"} </div>
                </div>
              </div>
              <div className="col-md-6 order-1 order-md-2">
                <div className="text-center">
                  {userDetails?.avatar && (
                    <img
                      src={userDetails?.avatar}
                      alt="logo"
                      className="rounded rounded-circle"
                      style={{ height: "150px", width: "150px", objectFit: "cover" }}
                    />
                  )}
                </div>
                <div className="text-center mt-3">Profile Photo</div>
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-end gap-2 pt-2">
              <Link to="/edit-profile">
                <Button type="primary" htmlType="submit">
                  Edit
                </Button>
              </Link>
              <Link to="/">
                <Button type="primary" className="bg-secondary" htmlType="button">
                  Cancel
                </Button>
              </Link>
            </div>

            {/* <div className="d-flex justify-content-end mt-4 w-100">
              <Link to="/edit-profile" className="btn btn-success me-1">
                Edit
              </Link>
              <Link to="/" className="btn btn-secondary">
                Cancel
              </Link>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}
